import * as React from 'react';
import { Outlet } from 'react-router-dom';
import {
  SidebarProvider,
  SidebarInset,
  SidebarTrigger,
} from '../components/ui/sidebar';
import { AppSidebar } from '../components/app-sidebar';
import { FieldInspectLegacyTheme } from '../components/fieldinspect-legacy-theme';
import { ToastProvider, useToast } from '../components/ui/toast';
import { TrialConvertedModal } from '../components/TrialConvertedModal';
import { WelcomeBackModal } from '../components/WelcomeBackModal';
import '../globals.css';

const V2_WELCOME_SHOWN_KEY = 'paiv_v2_welcome_shown';

function V2WelcomeToast() {
  const toast = useToast();

  React.useEffect(() => {
    const alreadyShown = localStorage.getItem(V2_WELCOME_SHOWN_KEY);
    if (!alreadyShown) {
      localStorage.setItem(V2_WELCOME_SHOWN_KEY, 'true');
      // Small delay so the layout renders first
      setTimeout(() => {
        toast.info(
          'Welcome to the new FieldInspect experience',
          'We have refreshed the interface to make things easier to use.'
        );
      }, 500);
    }
  }, []);

  return null;
}

export function V2Layout() {
  // Initialize theme on mount
  React.useEffect(() => {
    const savedTheme = localStorage.getItem('v2-theme');
    const prefersDark = window.matchMedia(
      '(prefers-color-scheme: dark)'
    ).matches;
    const shouldBeDark = savedTheme === 'dark' || (!savedTheme && prefersDark);

    if (shouldBeDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, []);

  return (
    <FieldInspectLegacyTheme>
      <ToastProvider>
        <V2WelcomeToast />
        <TrialConvertedModal />
        <WelcomeBackModal />
        <SidebarProvider className="bg-background text-foreground">
          <AppSidebar />
          <SidebarInset data-v2="">
            <div className="hidden md:flex items-center h-10 px-4 border-b border-border shrink-0">
              <SidebarTrigger className="size-7 text-foreground" />
            </div>
            <main className="flex-1 flex flex-col overflow-hidden min-w-0">
              <Outlet />
            </main>
          </SidebarInset>
        </SidebarProvider>
      </ToastProvider>
    </FieldInspectLegacyTheme>
  );
}
